// extracted by mini-css-extract-plugin
export default {"alert":"alert__1f197099","text":"text__1f197099","message":"message__1f197099","button":"button__1f197099","test":"test__1f197099"};